import { useEffect } from 'react';
import Step1_LotInformation from './Step1_LotInformation';
import Step1_PrepForm from './Step1_PrepForm';
import Step1_Calculations from './Step1_Calculations';

function PrepStep1({ palletData, formData, onDataChange, onValidationChange, prepScrapReasons, destinationLocations }) {
    const { totalUnits, numCases, unitsPerCase, numLooseUnits } = palletData;

    useEffect(() => {
        const numRPCs = parseInt(formData?.numRPCs, 10) || 0;
        const rpcsPerPallet = parseInt(formData?.rpcsPerPallet, 10) || 0;
        const unitsPerRPC = parseInt(formData?.unitsPerRPC, 10) || 0;
        const looseUnits = parseInt(formData?.looseUnits, 10) || 0;
        const scrapUnits = parseInt(formData?.scrapUnits, 10) || 0;

        // Rule 1: All required fields are filled with valid data.
        const requiredFieldsValid =
            numRPCs > 0 &&
            rpcsPerPallet > 0 &&
            unitsPerRPC > 0 &&
            !!formData?.moveToLocation &&
            (scrapUnits > 0 ? !!formData?.scrapReason : true);

        // Rule 2: The total accounted units do not exceed the total available units.
        const totalAccountedUnits = numRPCs * unitsPerRPC + looseUnits + scrapUnits;
        const totalUnitsValid = totalAccountedUnits <= totalUnits;

        onValidationChange(requiredFieldsValid && totalUnitsValid);
    }, [formData, totalUnits, onValidationChange]);

    return (
        <div className="space-y-4">
            <Step1_LotInformation
                totalUnits={totalUnits}
                numCases={numCases}
                unitsPerCase={unitsPerCase}
                numLooseUnits={numLooseUnits}
            />

            <Step1_PrepForm
                formData={formData}
                onDataChange={onDataChange}
                prepScrapReasons={prepScrapReasons}
                destinationLocations={destinationLocations}
            />

            <Step1_Calculations palletData={palletData} formData={formData} />
        </div>
    );
}

export default PrepStep1;
